import { getUserDomains } from "@/components/APIManager.js";
import { searchUsers } from "@/components/AdminAPIManager.js";

export default {
  data() {
    return {
      loadingUsers: false,
      allUsers: [],
      filteredSourceUsers: [],
      filteredTargetUsers: [],
      sourceEmailDomainFilter: "",
      targetEmailDomainFilter: "",
      availableDomains: [],
      filteredSourceDomains: [],
      filteredTargetDomains: [],
      selectedSourceUserId: null,
      selectedTargetUserId: null,
    };
  },

  methods: {
    async loadUsers() {
      try {
        this.loadingUsers = true;
        this.error = null;

        const pageSize = 200;
        let page = 1;
        let hasMore = true;
        const allUsers = [];

        while (hasMore) {
          const response = await searchUsers("", page, pageSize);
          if (response.status !== "success") {
            throw new Error("Failed to load users");
          }

          const users = response.data.users || [];
          allUsers.push(...users);
          hasMore = response.data.has_more === true;
          page += 1;
        }

        this.allUsers = allUsers;
        this.filteredSourceUsers = [];
        this.filteredTargetUsers = [];
      } catch (error) {
        this.error = "Failed to load users. Please try again.";
      } finally {
        this.loadingUsers = false;
      }
    },

    async loadDomains() {
      try {
        const response = await getUserDomains();

        if (response.status === "success") {
          this.availableDomains = response.data.domains || [];
        } else {
          throw new Error("Failed to load domains");
        }
      } catch (error) {
        this.availableDomains = this.extractDomainsFromUsers();
      }

      this.filteredSourceDomains = [...this.availableDomains];
      this.filteredTargetDomains = [...this.availableDomains];
    },

    filterSourceUsers() {
      if (!this.sourceEmailDomainFilter) {
        this.filteredSourceUsers = [];
        this.selectedSourceUserId = null;
        this.handleAdminSourceFilterChange?.();
        return;
      }

      const domain = this.sourceEmailDomainFilter.toLowerCase();
      this.filteredSourceUsers = this.allUsers.filter((user) => {
        if (!user.email) return false;
        const emailDomain = user.email.toLowerCase().split("@")[1];
        return emailDomain && (emailDomain === domain || emailDomain.includes(`.${domain}`));
      });

      this.selectedSourceUserId = null;
      this.handleAdminSourceFilterChange?.();
    },

    filterTargetUsers() {
      if (!this.targetEmailDomainFilter) {
        this.filteredTargetUsers = [];
        this.selectedTargetUserId = null;
        this.handleAdminTargetFilterChange?.();
        return;
      }

      const domain = this.targetEmailDomainFilter.toLowerCase();
      this.filteredTargetUsers = this.allUsers.filter((user) => {
        if (!user.email) return false;
        const emailDomain = user.email.toLowerCase().split("@")[1];
        return emailDomain && (emailDomain === domain || emailDomain.includes(`.${domain}`));
      });

      this.selectedTargetUserId = null;
      this.handleAdminTargetFilterChange?.();
    },

    filterSourceDomains(searchTerm) {
      if (!searchTerm) {
        this.filteredSourceDomains = [...this.availableDomains];
        return;
      }

      const term = searchTerm.toLowerCase();
      this.filteredSourceDomains = this.availableDomains.filter((domain) =>
        domain.toLowerCase().includes(term)
      );
    },

    filterTargetDomains(searchTerm) {
      if (!searchTerm) {
        this.filteredTargetDomains = [...this.availableDomains];
        return;
      }

      const term = searchTerm.toLowerCase();
      this.filteredTargetDomains = this.availableDomains.filter((domain) =>
        domain.toLowerCase().includes(term)
      );
    },

    extractDomainsFromUsers() {
      const domains = new Set();

      this.allUsers.forEach((user) => {
        if (user.email && user.email.includes("@")) {
          const domain = user.email.split("@")[1];
          if (domain && domain.includes(".")) {
            domains.add(domain);
          }
        }
      });

      return Array.from(domains).sort();
    },

    findUserById(userId) {
      return this.allUsers.find((user) => user.user_id === userId) || null;
    },

    formatUserSubtitle(user) {
      const parts = [];
      if (user.full_name) {
        parts.push(user.full_name);
      }
      if (user.organisation) {
        parts.push(user.organisation);
      }
      if (!parts.length && user.user_id) {
        parts.push(user.user_id);
      }
      return parts.join(" | ");
    },
  },
};
